import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { blockOrganisation, unblockOrganisation } from '@api/organisations';

import { IChangeStatusOrganisationDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATION_PROFILE, ORGANISATIONS, USERS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateBlockUnblockOrganisation = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleChangeStatusOrganisation,
		isLoading: isUpdatingOrganisationStatus,
	} = useMutation<IChangeStatusOrganisationDTO>({
		mutationKey: [ORGANISATIONS],
		mutationFn: async ({ id, isActive, closeModal }: {
			id: string;
			isActive: boolean;
			closeModal?: () => void;
		}) => {
			const toggleStatus = isActive ? blockOrganisation : unblockOrganisation;

			await toggleStatus(id);

			if (closeModal) closeModal();
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.statusChanged,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ORGANISATIONS]),
				queryClient.invalidateQueries([USERS]),
				queryClient.invalidateQueries([ORGANISATION_PROFILE]),
			];
		},
	});

	return {
		handleChangeStatusOrganisation,
		isUpdatingOrganisationStatus,
	};
};
